export class PageableRequest {
  pageNumber?: number;
  pageSize?: number;
  offset?: number;
}
